/* TITAN OS · interacción de la tienda (todo diferido; la página se ve y se compra sin esto).
   1. Barra de navegación: estado al bajar, menú de juegos, menú de celular.
   2. Apariciones al hacer scroll.
   3. Escenario del héroe: cambiar de artículo, inclinación 3D con el mouse.
   4. Rieles de productos con flechas.
   5. Producto: inclinación de la imagen y barra de compra fija en celular.
   6. Atribución: guarda de qué creador o red viene el visitante (?ref=, utm_*) y lo pega al carrito
      como atributo, para ver en cada pedido qué canal o creador generó la venta.
   7. Monedas Titan en la barra (lee window.TLC, que ya define el tema). */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  root.classList.add('to-js');

  /* 1 · Barra de navegación */
  var header = $('[data-to-header]');
  if (header) {
    // tl-scrolled: la mascota de registro se esconde al bajar (igual que en la versión anterior)
    var onScroll = function () { header.classList.toggle('is-stuck', scrollY > 12); root.classList.toggle('tl-scrolled', scrollY > 200); };
    onScroll();
    addEventListener('scroll', onScroll, { passive: true });

    $$('[data-to-mega]').forEach(function (btn) {
      var panel = d.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      var set = function (open) { btn.setAttribute('aria-expanded', String(open)); panel.classList.toggle('is-open', open); };
      btn.addEventListener('click', function (e) { e.stopPropagation(); set(btn.getAttribute('aria-expanded') !== 'true'); });
      var item = btn.closest('.to-nav__item');
      if (fine && item) {
        var t;
        item.addEventListener('mouseenter', function () { clearTimeout(t); set(true); });
        item.addEventListener('mouseleave', function () { t = setTimeout(function () { set(false); }, 180); });
      }
      d.addEventListener('click', function (e) { if (!e.target.closest('.to-nav__item')) set(false); });
      d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('is-open')) { set(false); btn.focus(); } });
    });

    var menuBtn = $('[data-to-menu-btn]'), drawer = $('[data-to-drawer]');
    if (menuBtn && drawer) {
      var setMenu = function (open) {
        menuBtn.setAttribute('aria-expanded', String(open));
        menuBtn.querySelector('use').setAttribute('href', open ? '#to-i-close' : '#to-i-menu');
        drawer.classList.toggle('is-open', open);
        drawer.toggleAttribute('inert', !open);
        header.classList.toggle('is-open', open);
        root.classList.toggle('to-menu-open', open);
      };
      menuBtn.addEventListener('click', function () { setMenu(menuBtn.getAttribute('aria-expanded') !== 'true'); });
      drawer.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
      d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) { setMenu(false); menuBtn.focus(); } });
    }
  }

  /* Volver arriba */
  var totop = $('[data-to-totop]');
  if (totop) {
    var showTop = function () { totop.classList.toggle('is-on', scrollY > innerHeight * 1.2); };
    showTop();
    addEventListener('scroll', showTop, { passive: true });
    // Con el scroll suave de to-motion.js (Lenis) se usa el suyo; sin él, el del navegador
    totop.addEventListener('click', function () {
      var L = window.TitanOS && TitanOS.lenis;
      L ? L.scrollTo(0, { duration: 1.4 }) : scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  /* 2 · Apariciones */
  var reveals = $$('.to-reveal');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* "En vivo": lo decorativo pesado (mercurio WebGL, GSAP, animaciones infinitas, rotación del escenario)
     arranca con la primera interacción (mover el mouse, tocar, rueda, scroll o una tecla) o 5 s después de
     cargar. Así los primeros segundos el celular solo se dedica a mostrar la tienda y quedar listo para tocar
     (eso es lo que miden LCP y TBT). Para quien la usa se ve igual: casi todos mueven el mouse o el dedo enseguida. */
  var LIVE_EVENTS = ['pointermove', 'pointerdown', 'wheel', 'touchstart', 'scroll', 'keydown'];
  var liveFns = [], isLive = false;
  var afterLoad = function (fn) { d.readyState === 'complete' ? fn() : addEventListener('load', fn, { once: true }); };
  // Cada pieza corre en su propio turno, cuando el navegador está libre: así ninguna junta un bloqueo largo
  // (un toque del cliente nunca espera a que termine todo el arranque)
  var idle = window.requestIdleCallback ? function (fn) { requestIdleCallback(fn, { timeout: 700 }); } : function (fn) { setTimeout(fn, 40); };
  var drain = function () { var fn = liveFns.shift(); if (!fn) return; fn(); if (liveFns.length) idle(drain); };
  var goLive = function () {
    if (isLive) return;
    isLive = true;
    LIVE_EVENTS.forEach(function (t) { removeEventListener(t, goLive, true); });
    // La clase va en el siguiente cuadro, no dentro del toque o del scroll que la disparó
    requestAnimationFrame(function () { root.classList.add('to-live'); });
    afterLoad(function () { idle(drain); });
  };
  var whenLive = function (fn) { liveFns.push(fn); if (isLive && liveFns.length === 1) afterLoad(function () { idle(drain); }); };
  if (!reduce) {
    LIVE_EVENTS.forEach(function (t) { addEventListener(t, goLive, { capture: true, passive: true }); });
    afterLoad(function () { setTimeout(goLive, 5000); });
  }

  /* 3 · Escenario del héroe */
  $$('[data-to-stage]').forEach(function (stage) {
    var items = $$('.to-stage__item', stage), thumbs = $$('.to-stage__thumb', stage);
    var name = $('[data-stage-name]', stage), meta = $('[data-stage-meta]', stage), price = $('[data-stage-price]', stage), buy = $('[data-stage-buy]', stage);
    var hero = stage.closest('.to-hero');
    if (items.length < 2) return;
    // Solo la primera foto viene en el HTML; las demás se piden justo antes de mostrarse
    var warm = function (el) {
      var img = el && $('img[data-srcset]', el);
      if (!img) return;
      img.srcset = img.dataset.srcset; img.src = img.dataset.src;
      img.removeAttribute('data-srcset'); img.removeAttribute('data-src');
    };
    var i = 0, timer = null, paused = false;
    var go = function (n, user) {
      i = (n + items.length) % items.length;
      var it = items[i];
      warm(it); warm(items[(i + 1) % items.length]);
      items.forEach(function (el, k) { el.classList.toggle('is-active', k === i); el.setAttribute('aria-hidden', String(k !== i)); });
      thumbs.forEach(function (b, k) { b.setAttribute('aria-pressed', String(k === i)); });
      if (name) name.textContent = it.dataset.name;
      if (meta) meta.textContent = it.dataset.meta;
      if (price) price.firstChild.nodeValue = it.dataset.price + ' ';
      if (buy) buy.href = it.dataset.url;
      if (hero) hero.style.setProperty('--to-acc', it.dataset.acc);
      stage.style.setProperty('--to-acc', it.dataset.acc);
      if (user) restart();
    };
    var restart = function () { clearInterval(timer); if (!reduce) timer = setInterval(function () { if (!paused && !d.hidden) go(i + 1); }, 5200); };
    thumbs.forEach(function (b, k) {
      b.addEventListener('click', function () { go(k, true); });
      b.addEventListener('pointerenter', function () { warm(items[k]); }, { passive: true });
    });
    stage.addEventListener('pointerenter', function () { paused = true; });
    stage.addEventListener('pointerleave', function () { paused = false; });
    // Deslizar con el dedo
    var sx = null;
    stage.addEventListener('pointerdown', function (e) { sx = e.clientX; });
    stage.addEventListener('pointerup', function (e) { if (sx !== null && Math.abs(e.clientX - sx) > 40) go(i + (e.clientX < sx ? 1 : -1), true); sx = null; });
    // Inclinación 3D con el mouse
    if (fine && !reduce) {
      var view = $('.to-stage__view', stage);
      view.addEventListener('pointermove', function (e) {
        var r = view.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        var t = $('.to-stage__item.is-active .to-stage__tilt', stage);
        if (t) t.style.transform = 'rotateY(' + (x * 22).toFixed(1) + 'deg) rotateX(' + (-y * 16).toFixed(1) + 'deg)';
      });
      view.addEventListener('pointerleave', function () { $$('.to-stage__tilt', stage).forEach(function (t) { t.style.transform = ''; }); });
    }
    // La rotación y la foto siguiente esperan a que la página esté "en vivo"
    whenLive(function () { warm(items[1]); restart(); });
  });

  /* Mercurio del héroe (to-liquid.js): solo con equipo y conexión que aguanten, y ya "en vivo" */
  var fx = $('[data-to-fx]');
  if (fx && !reduce) {
    var c = navigator.connection;
    var weak = (c && (c.saveData || /2g/.test(c.effectiveType || ''))) || (navigator.hardwareConcurrency || 8) <= 2;
    if (!weak) whenLive(function () { var s = d.createElement('script'); s.src = fx.dataset.src; s.defer = true; d.body.appendChild(s); });
  }

  /* Capa de movimiento (to-motion.js: letras interactivas, scroll suave y escenas con GSAP), también "en vivo".
     Sin ella la tienda funciona igual. */
  var A = window.TO_ASSETS;
  if (A && !reduce && !(navigator.connection && navigator.connection.saveData)) {
    var load = function (src) { return new Promise(function (ok, ko) { var s = d.createElement('script'); s.src = src; s.onload = ok; s.onerror = ko; d.head.appendChild(s); }); };
    whenLive(function () {
      load(A.gsap)
        .then(function () { return Promise.all([load(A.st), load(A.split), fine && A.lenis ? load(A.lenis) : null]); })
        .then(function () { return load(A.motion); })
        .catch(function () { /* sin animaciones: la tienda sigue igual */ });
    });
  }

  /* Elementos de las fichas (to-elements.js): fuego, hielo, rayos… alrededor del artículo. También "en vivo". */
  // Catálogo de frutas: recuerda la última fruta elegida, por si se abre antes de que cargue to-elements.js
  if (window.TO_EL_MAP) d.addEventListener('click', function (e) { var c = e.target.closest && e.target.closest('.tlf2-card[data-handle]'); if (c) window.TO_EL_LAST = c; }, true);
  if (A && A.elements && !reduce && ($('[data-to-el]') || window.TO_EL_MAP)) {
    whenLive(function () { var s = d.createElement('script'); s.src = A.elements; s.defer = true; d.body.appendChild(s); });
  }

  /* 4 · Rieles (también los que llegan después, como los relacionados) */
  var initRail = function (rail) {
    var track = $('.to-rail__track', rail), btns = $$('[data-dir]', rail);
    if (!track || rail.dataset.ready) return;
    rail.dataset.ready = '1';
    var upd = function () {
      var max = track.scrollWidth - track.clientWidth - 2;
      btns.forEach(function (b) { b.disabled = b.dataset.dir === '-1' ? track.scrollLeft <= 2 : track.scrollLeft >= max; });
    };
    btns.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: Number(b.dataset.dir) * track.clientWidth * .85, behavior: reduce ? 'auto' : 'smooth' }); }); });
    track.addEventListener('scroll', upd, { passive: true });
    addEventListener('resize', upd, { passive: true });
    // Medir el riel obliga al navegador a calcular toda la página: se hace cuando el riel se acerca a la
    // pantalla (ya calculada) y no al cargar, donde costaba ~340 ms en un celular de gama media
    if ('IntersectionObserver' in window) {
      var seen = new IntersectionObserver(function (en) { if (en[en.length - 1].isIntersecting) { seen.disconnect(); upd(); } }, { rootMargin: '300px 0px' });
      seen.observe(rail);
    } else upd();
  };
  $$('[data-to-rail]').forEach(initRail);
  window.TitanOS = { rails: function (scope) { $$('[data-to-rail]', scope).concat(scope.matches && scope.matches('[data-to-rail]') ? [scope] : []).forEach(initRail); } };

  /* Tarjetas: inclinación suave con el mouse */
  if (fine && !reduce) {
    var last = null;
    d.addEventListener('pointermove', function (e) {
      var card = e.target.closest && e.target.closest('.to-card');
      if (last && last !== card) { last.style.transform = ''; last = null; }
      if (!card) return;
      last = card;
      var r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      card.style.transform = 'perspective(900px) rotateY(' + (x * 8).toFixed(2) + 'deg) rotateX(' + (-y * 8).toFixed(2) + 'deg) translateY(-4px)';
    }, { passive: true });
  }

  /* 5 · Producto */
  var media = $('[data-tp-tilt]');
  if (media && fine && !reduce) {
    var tilt = $('.tp-media__tilt', media);
    media.addEventListener('pointermove', function (e) {
      var r = media.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      tilt.style.transform = 'rotateY(' + (x * 18).toFixed(1) + 'deg) rotateX(' + (-y * 14).toFixed(1) + 'deg)';
    });
    media.addEventListener('pointerleave', function () { tilt.style.transform = ''; });
  }
  var buybar = $('[data-tp-buybar]'), form = $('.tl-game-form');
  if (buybar && form && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      var e = en[en.length - 1], show = !e.isIntersecting && e.boundingClientRect.top < 0;
      buybar.classList.toggle('is-on', show);
      buybar.toggleAttribute('inert', !show);
      root.classList.toggle('to-has-buybar', show);
    }).observe(form);
    var go = $('[data-tp-buybar-go]', buybar);
    if (go) go.addEventListener('click', function () {
      var L = window.TitanOS && TitanOS.lenis;
      L ? L.scrollTo(form, { offset: -(innerHeight - form.offsetHeight) / 2 }) : form.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      var input = $('[data-tl-dato]', form);
      if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, reduce ? 0 : 450);
    });
  }

  /* 6 · Atribución de creadores y canales */
  try {
    var KEY = 'tl_attr', q = new URLSearchParams(location.search), fresh = {};
    ['ref', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (k) { var v = q.get(k); if (v) fresh[k] = v.slice(0, 60); });
    if (q.get('discount')) fresh.discount = q.get('discount').slice(0, 40);
    if (Object.keys(fresh).length) {
      fresh.landing = location.pathname.slice(0, 80);
      fresh.date = new Date().toISOString().slice(0, 10);
      localStorage.setItem(KEY, JSON.stringify(fresh));
      sessionStorage.removeItem(KEY + '_sent');
    }
    var saved = JSON.parse(localStorage.getItem(KEY) || 'null');
    var send = function () {
      if (!saved || sessionStorage.getItem(KEY + '_sent')) return;
      var attrs = {};
      Object.keys(saved).forEach(function (k) { attrs['Origen · ' + k] = saved[k]; });
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }),
      }).then(function (r) { if (r.ok) sessionStorage.setItem(KEY + '_sent', '1'); }).catch(function () {});
    };
    // Una vez por sesión: así también llega en "Comprar ahora", que salta directo al pago
    if (saved) send();
  } catch (e) { /* sin almacenamiento: no pasa nada */ }

  /* 7 · Monedas en la barra */
  var coins = $('[data-to-coins]');
  if (coins && window.TLC && TLC.in) coins.textContent = (TLC.coins || 0).toLocaleString('es-MX');

  /* 8 · Capa líquida
     - Botones: rebotan como gelatina al tocarlos (también en celular).
     - Con mouse: una luz suave sigue al cursor por debajo del vidrio, las tarjetas reflejan la luz donde
       está el cursor (--mx/--my) y los botones se dejan atraer un poco (magnéticos). */
  d.addEventListener('pointerdown', function (e) {
    var b = !reduce && e.target.closest && e.target.closest('.to-btn, .to-ibtn, .to-card__go');
    if (!b) return;
    b.classList.remove('is-jelly'); void b.offsetWidth; b.classList.add('is-jelly');
  }, { passive: true });
  d.addEventListener('animationend', function (e) { if (e.animationName === 'to-jelly') e.target.classList.remove('is-jelly'); });

  if (fine && !reduce) {
    var glow = d.createElement('div');
    glow.className = 'to-cursor'; glow.setAttribute('aria-hidden', 'true');
    d.body.appendChild(glow);
    var gx = innerWidth / 2, gy = innerHeight / 3, tgx = gx, tgy = gy, gRaf = 0, mag = null;
    var gLoop = function () {
      gx += (tgx - gx) * .12; gy += (tgy - gy) * .12;
      glow.style.transform = 'translate3d(' + gx.toFixed(1) + 'px,' + gy.toFixed(1) + 'px,0)';
      gRaf = Math.abs(tgx - gx) + Math.abs(tgy - gy) > .4 ? requestAnimationFrame(gLoop) : 0;
    };
    var LIT = '.to-btn, .to-ibtn, .to-card, .to-game, .to-perk, .to-qa, .to-discord, .tp-box, .to-step, .to-mega__link, .to-stage__hud';
    d.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      tgx = e.clientX; tgy = e.clientY;
      glow.classList.add('is-on');
      if (!gRaf) gRaf = requestAnimationFrame(gLoop);
      var el = e.target.closest && e.target.closest(LIT);
      if (el) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', (e.clientX - r.left).toFixed(0) + 'px');
        el.style.setProperty('--my', (e.clientY - r.top).toFixed(0) + 'px');
        // En fracción (0 a 1): mueve el brillo holográfico de las tarjetas
        el.style.setProperty('--px', ((e.clientX - r.left) / r.width).toFixed(3));
        el.style.setProperty('--py', ((e.clientY - r.top) / r.height).toFixed(3));
      }
      var b = el && el.matches('.to-btn, .to-ibtn') ? el : null;
      if (mag && mag !== b) { mag.style.translate = ''; mag = null; }
      if (b) {
        var br = b.getBoundingClientRect();
        b.style.translate = (((e.clientX - br.left) / br.width - .5) * 10).toFixed(1) + 'px ' + (((e.clientY - br.top) / br.height - .5) * 8).toFixed(1) + 'px';
        mag = b;
      }
    }, { passive: true });
    root.addEventListener('mouseleave', function () { glow.classList.remove('is-on'); if (mag) { mag.style.translate = ''; mag = null; } });
  }
})();
